"use client";
import { MenuItem } from "../lib/features/menus/menus.types";
import { setMenus } from "../lib/features/menus/menus.slice";
import { store } from "../lib/store";

interface MenusInitializerProviderProps {
  initialMenus?: MenuItem[] | null;
}

/**
 * SSR'dan gelen menü verisini mount öncesi Redux store'a senkron yazar.
 * SettingsInitializerProvider / HeaderInitializerProvider ile aynı pattern:
 * - initialMenus varsa → store'a senkron yaz, AppEffects'deki fetchMenus() skip eder
 *   (menus.thunk condition: data varsa return false).
 * - initialMenus yoksa → AppEffects fetchMenus() normal akışla çeker.
 */
const MenusInitializerProvider = ({ initialMenus }: MenusInitializerProviderProps) => {
  if (initialMenus && !store.getState().menus.data) {
    store.dispatch(setMenus(initialMenus));
  }
  return null;
};

export default MenusInitializerProvider;